<template>
  <div class="row">
    <div class="col-12 mb-3">
      <em class="fas fa-info-circle text-orange mr-1" />
      <span>Información Adicional</span>
    </div>
    <div class="col-12 col-md">
      <span class="data-name">
        Área:
      </span>
      <p class="font-16">
        {{ value.area?.name | empty }}
      </p>
    </div>
    <div class="col-12 col-md">
      <span class="data-name">
        Fecha de Ultima Actualización:
      </span>
      <p class="font-16">
        {{ value.updatedDate ?? value.createdDate | date }}
      </p>
    </div>
    <div class="col-12 col-md">
      <span class="data-name">
        Usuario:
      </span>
      <p class="font-16">
        {{ value.updatedBy ?? value.createdBy | empty }}
      </p>
    </div>
    <div class="col-12">
      <span class="data-name">
        Servicio a Ofrecer:
      </span>
      <p class="font-16">
        {{ value.service?.name | empty }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalInfo',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss"></style>
